import SingleSelect, { TSingleSelectType } from '../components/SingleSelect';
import ChannelLabel from '@op/components/ChannelLabel';
import React from 'react';
import { TComponentConfig } from '../types';
import { getSingleSelectDefaultValue } from '../utils';
import { channelOptions } from '../constants/channels';

export const Channel: TComponentConfig<TSingleSelectType> = {
  Component: SingleSelect,
  defaultValue: (filterValue: any, props: TSingleSelectType) => {
    const { valueKeys: key, options } = props;
    return getSingleSelectDefaultValue(filterValue, key, options);
  },
  backValue: (filterValue: any, props: TSingleSelectType) => {
    const { valueKeys: key } = props;
    return { [key]: [filterValue[key]] };
  },
  props: {
    title: 'Channel',
    titleCn: '渠道',
    valueKeys: 'channels',
    itemRender: (item: any) => (
      <ChannelLabel
        iconStyle={{ width: 18, height: 18 }}
        channel_name={item?.value as 'tiktok'}
      />
    ),
    options: channelOptions,
  },
};
